import { render, staticRenderFns } from "./detailReceivableInfo.vue?vue&type=template&id=5dde38cb"
import script from "./detailReceivableInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./detailReceivableInfo.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports